import {Grid, Typography, createTheme, ThemeProvider, Divider, Badge, styled} from '@mui/material';
import {IRaciRoleBadge} from 'app/types/Shared';
import React from 'react';

const StyledBadge = styled(Badge)({
  '& .MuiBadge-badge': {
    color: 'white',
  },
});
//Create theme for RACI Badges. Set Custom Badge colors
const theme = createTheme({
  palette: {
    primary: {
      main: '#ABB436', // change primary color for R
    },
    secondary: {
      main: '#EA5532', // change secondary color for A
    },
    warning: {
      main: '#DA5283', // change waring color for C
    },
    error: {
      main: '#51B1BF', // change error color for I
    },
    info: {
      main: '#EEEEEE', // change primary color for unselected
    },
  },
});

// returns the badge color based on RACI letter. See theme above for custom color that are set
const getBadgeColor = (s: string) => {
  if (s === 'R') {
    return 'primary';
  }
  if (s === 'A') {
    return 'secondary';
  }
  if (s === 'C') {
    return 'warning';
  } else {
    return 'error';
  }
};

type BadgeProps = {
  step: Array<IRaciRoleBadge>;
};

const RaciColumn = (raci: string, title: string) => {
  const raciArr = raci.split(';');

  const getRaciBadge = (position: number) => {
    if (position === 0 && raciArr.find((r) => r === 'R')) {
      return <StyledBadge badgeContent={'R'} color={getBadgeColor('R')} />;
    } else if (position === 1 && raciArr.find((r) => r === 'A')) {
      return <StyledBadge badgeContent={'A'} color={getBadgeColor('A')} />;
    } else if (position === 2 && raciArr.find((r) => r === 'C')) {
      return <StyledBadge badgeContent={'C'} color={getBadgeColor('C')} />;
    } else if (position === 3 && raciArr.find((r) => r === 'I')) {
      return <StyledBadge badgeContent={'I'} color={getBadgeColor('I')} />;
    } else return <></>;
  };

  return (
    <Grid container direction='row' display='flex' alignItems='center' spacing={3}>
      <Grid item xs={7} textAlign='left' sx={{maxWidth: 200}}>
        <Typography
          sx={{wordWrap: 'break-word', maxWidth: '30ch'}}
          flexGrow={1}
          fontSize='14px'
          variant='subtitle1'
          pl={1}
        >
          {title}
        </Typography>
      </Grid>
      <Grid item xs={5} container spacing={4}>
        {[0, 1, 2, 3].map((raciPosition, inx) => (
          <Grid item xs={1.25} key={`RACIBADGE-${title}-${raciPosition}.${inx}`}>
            {getRaciBadge(raciPosition)}
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
};

const RACIBadgedRole: React.FC<BadgeProps> = (step: BadgeProps) => {
  return (
    <ThemeProvider theme={theme}>
      {step.step.map((item, index) => (
        <React.Fragment key={`RACI-${item.role.name}-${index}-${item.raci_list}`}>
          <Grid container direction='row' alignContent='center' justifyContent='flex-start' mb={0.5}>
            <Grid item xs={12}>
              {RaciColumn(item.raci_list, item.role.desc ? item.role.desc : item.role.name)}
            </Grid>
          </Grid>
          <Divider sx={{mb: 1}} />
        </React.Fragment>
      ))}
    </ThemeProvider>
  );
};

export default RACIBadgedRole;
